import { BrandCodeEnum } from "src/graphql/generated/types";
import { useBrandStore } from "src/stores/brand-store";

import { useCurrentCustomer } from "./use-current-customer";

export function useIsInformationUpdateBannerShown(): boolean {
  const { shouldShowInformationUpdateBanner } = useCurrentCustomer();
  const isFoncia = useBrandStore(
    (state) => state.brandCode === BrandCodeEnum.Foncia,
  );

  return isFoncia && shouldShowInformationUpdateBanner;
}
